import { render, staticRenderFns } from "./ScopeTreePreview.vue?vue&type=template&id=45f8c3bc&scoped=true"
import script from "./ScopeTreePreview.vue?vue&type=script&lang=js"
export * from "./ScopeTreePreview.vue?vue&type=script&lang=js"
import style0 from "./ScopeTreePreview.vue?vue&type=style&index=0&id=45f8c3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8c3bc",
  null
  
)

export default component.exports